export const sortByCreatedOn = (objectsToSort: any[]): any[] => {
  return objectsToSort?.sort((a: any, b: any) => {
    const dateA = a?.created_on
    const dateB = b?.created_on
    if (typeof dateA === 'string' && typeof dateB === 'string') {
      return new Date(dateA).getTime() - new Date(dateB)?.getTime()
    }
    return -1
  })
}